import { searchBusinessTerm } from '@wix/ambassador-funnel-taxonomy-v1-business-term/http'
import type { BusinessTerm } from '@wix/ambassador-funnel-taxonomy-v1-business-term/types'
import { getBusinessTermById } from '@wix/ambassador-funnel-taxonomy-v2-business-term/http'
import { IHttpClient } from '@wix/http-client'

import { withMonitoring } from '../../../../monitoring/withMonitoring'

export class BusinessTermService {
  constructor(private readonly httpClient: IHttpClient) {}

  async search({
    query,
    limit,
    language,
  }: {
    query: string
    limit: number
    language: string
  }): Promise<BusinessTerm[]> {
    // API has limitation of 100 characters
    if (query.length >= 100) {
      return []
    }
    const request = searchBusinessTerm({ q: query, limit, locale: language })
    const res = await withMonitoring(() => this.httpClient.request(request), 'Category-loadCategories')
    return res.data.results || []
  }

  async getBusinessSegmentIdByTermId(businessTermId: string): Promise<string | undefined> {
    const request = getBusinessTermById({ businessTermId })
    let businessSegmentId
    try {
      const res = await withMonitoring(() => this.httpClient.request(request), 'Category-loadBusinessSegment')
      businessSegmentId = res.data.businessTerm?.businessSegmentId || undefined
    } catch (e) {
      console.error('Failed to get business segment id', e)
    }
    return businessSegmentId
  }
}
